export const QMS_DOCTYPE_SYMBOL = {
  0: "OTHER",
  1: "SS",
  2: "SPL",
  3: "MANUAL",
  4: "AUDIT",
  5: "BCM",
};

export const statusOptions = [
  { label: "To Do", value: 1 },
  { label: "In Progress", value: 2 },
  { label: "Completed", value: 3 },
];
